<template>
  <div
    :class="dateRangeButtonClass"
    class="daterangepicker-btn"
  >
    <i class="fa fa-calendar" />
    <span ref="rangeText" />
    <strong class="caret" />
  </div>
</template>

<script>
import 'bootstrap-daterangepicker/daterangepicker';
import $ from 'jquery';
import moment from 'moment';
import { isMoment } from 'moment';

import {formatTimeInTimeZone} from '@/data/getDateRanges';

const defaultOptions = {
  buttonClasses: 'btn btn-sm',
  applyClass: 'btn-primary',
  cancelClass: 'btn-danger m-l-10'
};

export default {
  name: 'DateRangePicker',
  props: {
    dateRangeButtonClass: {
      type: String,
      default: ''
    },
    dateRange: {
      type: Array,
      validator(value) {
        if (
          (value[0] && !isMoment(value[0])) ||
          (value[1] && !isMoment(value[1]))
        ) {
          return false;
        }

        return true;
      },
      default() {
        return [moment().tz(this.timeZoneId), moment().tz(this.timeZoneId)];
      }
    },
    options: {
      type: Object,
      default() {
        return {};
      }
    },
    format: {
      type: String,
      default: 'MMM D, YYYY HH:mm'
    },
    timeZoneId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      pickerElement: null
    };
  },
  computed: {
    startDate() {
      return this.range[0] || moment().tz(this.timeZoneId);
    },
    endDate() {
      return this.range[1] || moment().tz(this.timeZoneId);
    },
    customOptions() {
      return {
        locale: {
          format: this.format
        },
        timePickerSeconds: true,
        startDate: this.startDate,
        endDate: this.endDate,
        ...defaultOptions,
        ...this.options
      };
    },
    range: {
      get() {
        return this.dateRange;
      },
      set(newValue) {
        this.$emit('input', newValue);
        this.$emit('change', newValue);
        this.emitNewRange(newValue);
        this.setNewRangeOnUI(newValue);
      }
    }
  },
  watch: {
    dateRange(newValue) {
      this.setNewRangeOnUI(newValue);
    },
    options(newValue) {
      this.initializeDateRangePicker({
        ...this.customOptions,
        ...newValue
      });
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initializeDateRangePicker({
        ...this.customOptions
      });

      this.setNewRangeOnUI(this.range);
    });
  },
  beforeDestroy() {
    $(this.$el)
      .daterangepicker('hide')
      .daterangepicker('destroy');
  },
  methods: {
    emitNewRange(newRange) {
      if(this.pickerElement) {
        const el = this.pickerElement.data('daterangepicker');
        const isCustomRange = !el.ranges[el.chosenLabel];
        this.$emit('onDateRangeChange', {
          quickRangeSelector: el.chosenLabel,
          timeRange: newRange,
          isCustomRange
        });
      }
    },

    setNewRangeOnUI(newRange) {
      if (!newRange || !this.pickerElement) {
        return;
      }

      const el = this.pickerElement.data('daterangepicker');

      if (el) {
        el.setStartDate(newRange[0]);
        el.setEndDate(newRange[1]);
      }

      this.$refs['rangeText'].textContent = `${formatTimeInTimeZone(newRange[0], this.timeZoneId, this.format)} - ${formatTimeInTimeZone(newRange[1], this.timeZoneId, this.format)}`;
    },

    initializeDateRangePicker(options) {
      this.pickerElement = $(this.$el);
      this.pickerElement.daterangepicker(options);

      this.pickerElement.on('apply.daterangepicker', (event, picker) => {
        this.range = [picker.startDate, picker.endDate];
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.daterangepicker-button {
  @include reporting-button-bar();

  &:before,
  &:after {
    display: none;
  }
}
</style>